// i18n area 'vms' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.no-NO.meta.json.
import type { enUS } from './vms'

export const noNO: typeof enUS = {
  vms: {
    spof: {
      title: 'Uavhengighet fra noden',
      single: 'Enkelt feilpunkt',
      alternativesNow: 'Alternativer nå',
      structural: 'Etter konstruksjon',
      binding: 'Bindende begrensning',
      movableNow: 'Kan migreres nå',
    },
    title: 'Virtuelle maskiner',
    migratingChip: 'Migrering pågår',
    templateChip: 'Template',
    expendableTooltip: 'I en degradert klynge er den blant de første som stoppes, og starter kanskje ikke på nytt etter tap av en node.',
    expendableHaTooltip: 'Startes alltid på nytt så lenge klyngen er frisk; i en degradert klynge kommer beskyttede VM-er først — den kan stoppes eller forbli av til klyngen er hel igjen, deretter kommer den tilbake av seg selv.',
    viewDetails: 'Se detaljer',
    profileLegacy: 'Annet OS',
    hugePagesNone: 'Ingen — vanlig minne',
    hugePages2M: '2 MiB-sider',
    hugePages1G: '1 GiB-sider',
    searchPlaceholder: 'Søk etter navn',
    name: 'Navn',
    vcpus: 'vCPU',
    memory: 'Minne',
    ipAddresses: 'IP-adresser',
    noIp: 'Ingen IP',
    authorityNode: 'Authority',
    authorityNextStart: 'tildeles ved neste start',
    scope: 'Scope',
    empty: 'Ingen virtuelle maskiner',
    loadError: 'Kunne ikke laste de virtuelle maskinene — er TVirt-backenden tilgjengelig?',
    filterOverlay: 'overlay-nettverk',
    filterDisk: 'disk',
    filterImage: 'bilde',
    filteredBy: 'Filtrert etter {kind}',
    filterPhase: 'Fase',
    filterProtection: 'Beskyttelse',
    filterAll: 'Alle',
    filterScopePlaceholder: 'Filtrer etter scope',
    filtersToggle: 'Filtre',
    scopeTree: {
      title: 'Scoper',
      all: 'Hele klusteret',
      noChildren: 'Ingen under-scoper her',
      recursive: 'Ta med etterkommere',
      collapse: 'Skjul scope-panelet',
      up: 'Ett nivå opp',
      countTooltip: '{direct} VM-er i denne scopen · {total} med etterkommere'
    },
    isoPicker: {
      catalog: 'Katalog',
      unknownCatalog: 'Utenfor de synlige katalogene',
      noIsos: 'Ingen klare ISO-bilder i denne katalogen'
    },
    actionsHeader: 'Handlinger',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Hardware',
      tags: 'Tagger',
      age: 'Alder',
      disk: 'disk',
      disks: 'disker',
      empty: 'Ingen templater — merk en avslått VM som template, eller klon en VM som template.',
      clone: 'Klon / deploy',
      editTags: 'Rediger tagger',
      exportAction: 'Eksporter til katalogen (.tvtpl)',
      exportTitle: 'Eksporter til katalogen',
      exportSubmit: 'Eksporter',
      exportError: 'Eksporten mislyktes',
      exportHint: 'Templaten pakkes inn i et .tvtpl-arkiv (hardware-manifest + hver disk flatet ut til qcow2) som ny VM Template-fil i den valgte katalogen. NIC-er, CD/DVD-medier og cloud-init blir ikke med — formatspesifikasjonen lister hver bevisste utelatelse.',
      exportName: 'Filnavn',
      exportNameHint: 'Tomt = <template>-export-<n>',
      exportStorageDefault: 'Templatens metadata-storage',
      importAction: 'Importer fra katalog',
      importTitle: 'Importer fra katalog',
      importHint: 'En ready VM Template-fil fra den valgte katalogen blir en template i inventaret: filens format (tvtpl, ova, ovf eller naken qcow2) avgjør alene hvordan den importeres — du velger bare filen.',
      importFile: 'Katalogfil',
      importFileHint: 'Bare ready filer kan importeres — en midt i opplastingen er ikke importerbar',
      importNoFiles: 'Ingen ready VM Template-fil i denne katalogen — last opp eller eksporter en først'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy-kompatibilitet',
      quickDeployNone: 'Ikke erklært',
      quickDeployHint: 'Erklær den bare hvis golden-imaget inneholder cloud-init (Linux) eller cloudbase-init etter sysprep /generalize (Windows): plattformen stoler på erklæringen og ser aldri inn i gjesten.',
      notFound: 'Fant ikke templaten',
      frozen: 'Hardware-konfigurasjonen er frosset: konverter templaten tilbake til VM for å endre den. Navn, notater og tagger forblir redigerbare.',
      storage: 'Storage',
      size: 'Størrelse',
      configTitle: 'Konfigurasjon (frosset)',
      usbClasses: 'Påkrevde USB-klasser',
      gpuClasses: 'Påkrevde GPU-klasser'
    },
    sharedDisksTab: {
      title: 'Delte disker',
      sharing: 'Deling',
      sharingNone: 'Én tilkobling',
      sharingMultiwriter: 'Delt skriving (multiwriter)',
      sharingReadonly: 'Delt skrivebeskyttet',
      usedBy: 'I bruk av',
      attachedTo: 'Tilkoblet',
      notAttached: 'Ikke tilkoblet noen VM',
      changeSharing: 'Endre delingsmodus',
      changeSharingTitle: 'Delingsmodus',
      changeSharingLocked: 'Modusen endres bare mens ingen VM bruker disken',
      sharingChanged: 'Delingsmodus oppdatert.',
      lun: 'Hel LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Serienummer',
      antiAffinityWarning: 'To eller flere medlemmer kjører på samme node uten en anti-affinitetsregel: ett nodebrudd tar ned alle',
      antiAffinityCreate: 'Opprett regelen',
      createSourceLun: 'Overta en hel LUN fra targetet',
      createLunNumber: 'LUN-nummer (namespace-id på NVMe)',
      createLunHint: 'Ingenting allokeres: størrelsen leses fra enheten ved overtakelsen',
      noPr: 'Ingen SCSI-3 persistent reservations i denne utgaven: et Windows Failover Cluster med klassisk delt disk er ikke validert; klynger som koordinerer over nettet (GFS2/OCFS2, RHEL HA, shared-disk-databaser) er det'
    },
    unusedDisksTab: {
      title: 'Ubrukte disker',
      attach: 'Koble til en VM',
      attachTitle: 'Koble til en VM',
      vm: 'Virtuell maskin',
      noVms: 'Ingen VM tilgjengelig',
      noSlots: 'Ingen ledig slot på denne VM-en',
      create: 'Opprett disk',
      createTitle: 'Opprett disk',
      createSourceBlank: 'Tom disk',
      createSourceImage: 'Fra et bilde i katalogen',
      createImage: 'Bilde',
      createImageEmpty: 'Ingen klar VM-malbilde i de synlige katalogene',
      createSizeFromImageHint: 'Forhåndsutfylt med bildets virtuelle størrelse — den kan bare vokse',
      convert: 'Konverter til VM-template…',
      convertOnlyQcow2: 'Bare qcow2-disker kan konverteres — raw er ikke et registrerbart template-format',
      convertTitle: 'Konverter til VM-template',
      convertSubmit: 'Konverter (ødelegger disken)',
      convertError: 'Kunne ikke starte konverteringen',
      convertWarning: 'DESTRUKTIVT: disken blir en VM-template-fil i den valgte katalogen — samme storage, null byte kopiert — og OPPHØRER Å EKSISTERE som disk. Det finnes ingen vei tilbake annet enn å opprette en ny disk fra templaten.',
      convertNameHint: 'Navnet på katalogfilen — default er diskens eget',
      convertConfirm: 'Jeg forstår: disken blir ødelagt',
      convertStarted: 'Konverteringen er startet — templaten dukker opp i katalogen når tasken er ferdig.',
      storageLockHint: 'Storagen endres bare gjennom handlingen Flytt',
      source: 'Opphav',
      sourceClone: 'Klon av en annen disk',
      sourceCloneLinked: 'Linked clone av en annen disk',
      sourceImage: 'Opprettet fra et bilde',
      sourceBlank: 'Opprettet tom',
      allocated: 'Allokert / virtuell størrelse',
      observedAt: 'Observert',
      snapshots: 'Snapshots',
      snapshotsEmpty: 'Ingen snapshots'
    },
    phase: {
      defined: 'Aldri slått på',
      starting: 'Starter',
      running: 'Kjører',
      stopping: 'Stopper',
      stopped: 'Avslått',
      paused: 'Pauset',
      failed: 'Feilet',
      deleting: 'Slettes'
    },
    stopCause: {
      'api': 'Stoppet av TVirt (handling eller API)',
      'guest-shutdown': 'Nedstenging startet av guest-OS-et',
      'crash': 'Krasj i guesten',
      'qemu-exit': 'QEMU-prosessen avsluttet uventet',
      'host-reboot': 'Noden ble startet på nytt',
      'migrated': 'Migrert til en annen node',
      'fenced': 'Terminert av HA-fencing (node som kom tilbake)'
    },
    detail: {
      notFound: 'Fant ikke den virtuelle maskinen',
      details: 'Detaljer',
      id: 'ID',
      scope: 'Scope',
      profile: 'Hardware-profil',
      firmware: 'Firmware',
      firmwareFile: 'UEFI-firmwareversjon',
      firmwareUpdate: 'Oppdatering tilgjengelig',
      firmwareUpdateHint: 'Plattformen leverer en nyere UEFI-firmware. Oppdateringen skjer aldri automatisk: den brukes mens VM-en er avslått, når du bestemmer det.',
      arch: 'Arkitektur',
      node: 'Node',
      bootOrder: 'Boot-rekkefølge',
      agent: 'Agent-status',
      agentConnected: 'Tilkoblet',
      agentNotConnected: 'Ikke tilkoblet',
      protected: 'Beskyttet',
      linkedClones: 'Lenkede kloner',
      restartPolicy: 'Omstartspolicy',
      preferredNode: 'Foretrukket node',
      noPreference: 'Ingen preferanse (automatisk placement)',
      preferNodes: 'Foretrukne node-tagger',
      requireNodes: 'Påkrevde node-tagger',
      noPlacementTags: 'Ingen',
      placementTag: 'Tagg',
      placementValue: 'Verdi',
      placementAddTag: 'Legg til tagg',
      proximityHa: 'HA i TVirt Proximity',
      proximityHaRestarts: 'HA-omstarter',
      proximityHaGaveUp: 'crash-loop — HA har gitt opp',
      failoverProtection: 'Beskyttelse i degradert klynge',
      protectionProtected: 'Beskyttet',
      protectionExpendable: 'Kan ofres ved degradering',
      protectionInherit: 'Arv',
      lastStop: 'Siste stopp',
      yes: 'Ja',
      no: 'Nei',
      tabOverview: 'Oversikt',
      tabSnapshots: 'Snapshots',
      tabBackups: 'Kopier',
      hardware: 'Hardware',
      name: 'Navn',
      hwSystem: 'System',
      hwCpu: 'CPU',
      hwMemory: 'Minne',
      hwBoot: 'Oppstart',
      hwIdentity: 'Identitet',
      hwCluster: 'Kluster og agent',
      cpuTopology: 'CPU-topologi',
      cpuModel: 'CPU-modell',
      cpuLimit: 'CPU-grense',
      cpuWeight: 'CPU-vekt',
      cpuNested: "Nøstet virtualisering",
      cpuNestedHint: "Eksponerer vmx/svm for gjesten (kun med CPU-modellen host). På en kjørende VM gjelder endringen fra neste power cycle (PendingRestart); plassering tillater bare noder med nested aktivert.",
      unlimited: 'Ubegrenset',
      memory: 'Minne',
      balloon: 'Balloon',
      hugePages: 'Enorme sider',
      hugePagesTradeoff: 'Mindre adresseoversettingsarbeid og minne som aldri havner på disk; til gjengjeld er reservasjonen låst på noden så lenge den virtuelle maskinen kjører, minnet dedupliseres ikke lenger, og oppstarten feiler hvis noden har for få ledige sider.',
      disks: 'Disker',
      cdroms: 'CD/DVD-stasjoner',
      nics: 'Nettverksgrensesnitt',
      slot: 'Slot',
      disk: 'Disk',
      encrypted: 'Kryptert',
      image: 'Bilde',
      emptyDrive: 'Tom stasjon',
      emptyOption: '(tom)',
      network: 'Nettverk',
      mac: 'MAC',
      connected: 'Tilkoblet',
      unplugged: 'Frakoblet',
      noDevices: 'Ingen',
      screenshot: 'Screenshot',
      capturedAt: 'Tatt kl.',
      noCapture: 'Ingen screenshot ennå',
      snapshotName: 'Navn',
      snapshotCreated: 'Opprettet',
      snapshotMemory: 'Minne inkludert',
      noSnapshots: 'Ingen snapshots',
      pendingRestart: 'Endringer venter: de tas i bruk ved neste power cycle.',
      applied: 'i bruk',
      appliedHint: 'VM-en kjører med denne verdien — den konfigurerte tas i bruk ved neste power cycle.',
      actionError: 'Handlingen mislyktes',
      actionStillRunning: 'Handlingen pågår fortsatt — utfallet er ennå ikke kjent',
      tabConsole: 'Konsoll',
      consoleConnect: 'Koble til',
      consoleDisconnect: 'Koble fra',
      consoleConnecting: 'Kobler til…',
      consoleReconnecting: 'Kobler til…',
      consoleUnavailable: 'Konsollen er tilgjengelig mens VM-en kjører eller er pauset.',
      consoleError: 'Tilkoblingen til konsollen mislyktes',
      consoleTaken: 'Konsollsesjonen ble overtatt av {user}',
      consoleReconnect: 'Koble til igjen',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Hold {key} nede',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Åpne i fullskjerm i en ny fane',
      consoleLoadFailed: 'Fant ikke VM-en, eller utilstrekkelige tillatelser',
      consoleClose: 'Lukk',
      tabStats: 'Statistikk',
      tabTasks: 'Tasks',
      tabLogs: 'Logg',
      statsCpu: 'CPU',
      statsMemory: 'Minne',
      statsDisk: 'Disk-I/O',
      statsRange: 'Intervall',
      statsNoData: 'Ingen data i intervallet — statistikken samles inn mens VM-en kjører.',
      statsError: 'Kunne ikke laste statistikken',
      cpuUsage: 'Bruk',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Brukt',
      memGuestAvailable: 'Tilgjengelig (guest)',
      schema: 'Schema',
      consoleProtocol: 'Konsoll',
      agentEnabled: 'Guest-agent',
      metadataStorage: 'Metadata-storage',
      startupOnBoot: 'Start ved boot',
      startupOrder: 'Startrekkefølge',
      startupDelay: 'Startforsinkelse',
      seconds: 's',
      enabled: 'Aktivert',
      disabled: 'Deaktivert'
    },
    actionsAvailable: 'Tilgjengelige handlinger',
    actions: {
      start: 'Start',
      stop: 'Stopp',
      pause: 'Pause',
      resume: 'Gjenoppta',
      reset: 'Reset',
      migrate: 'Migrer',
      clone: 'Klon',
      moveStorage: 'Flytt til storage…',
      moveScope: 'Flytt til scope…',
      openConsole: 'Åpne konsoll',
      forceStop: 'Tving stopp',
      markTemplate: 'Merk som template',
      unmarkTemplate: 'Konverter tilbake til VM',
      error: 'Kunne ikke utføre handlingen'
    },
    cordon: {
      confirmTitle: 'Noden er i vedlikehold',
      confirmHint:
        'Kordongen kan ikke senkes mens klyngens store er nede. Ved å bekrefte erklærer du at du vet det: den virtuelle maskinen starter der likevel, og samtykket blir registrert på oppgaven.',
      confirm: 'Start likevel'
    },
    markTemplate: {
      confirmTitle: 'Merke {name} som template?',
      confirmBody: 'Konfigurasjonen fryses og VM-en kan ikke lenger slås på — bare klones, eller bli VM igjen. Navn, notater og tagger forblir redigerbare.',
      confirm: 'Merk som template',
      moved: '{name} er nå en template — den er flyttet til fanen Templater.'
    },
    unmarkTemplate: {
      confirmTitle: 'Konvertere {name} tilbake til VM?',
      confirmBody: 'Templaten blir en vanlig VM igjen: redigerbar og startbar (neste start plasserer den på en node).',
      confirm: 'Konverter tilbake til VM',
      moved: '{name} er en virtuell maskin igjen — den er flyttet til fanen Virtuelle maskiner.'
    },

    // Round #123: riferimento a nodo per TAG (selettore #106) nei dialog
    // di start e migrazione — anteprima dell'insieme risolto inclusa.
    nodeByTag: {
      label: 'Etter node-tag',
      hint: 'tag=verdi, kommaseparert (AND): decideren velger blant de matchende nodene',
      invalid: 'Ugyldig format — bruk tag=verdi, kommaseparert',
      resolved: 'Matchende medlemmer: {nodes}'
    },
    migrate: {
      title: 'Live-migrering',
      submit: 'Migrer',
      target: 'Målnode',
      auto: 'Automatisk (Proximity)',
      hint: 'VM-en flytter uten power cycle. Hver storage den berører må være delt; en pauset VM migrerer pauset.',
      error: 'Migreringen ble avvist'
    },
    moveStorage: {
      title: 'Flytt til storage',
      submit: 'Flytt',
      target: 'Mål-storage',
      noTargets: 'Ingen storage tar imot disker',
      hint: 'Alle diskene til den avslåtte VM-en flyttes til den valgte storagen, én om gangen, og beholder id-en sin — de som allerede er fremme hoppes over. Fremdriften følger du på task-siden.',
      error: 'Flyttingen ble avvist'
    },
    moveScope: {
      title: 'Flytt til scope',
      submit: 'Flytt',
      target: 'Mål-scope',
      hint: 'VM-en bytter scope umiddelbart — id og disker består, diskene den eier følger med, og den kan forbli påslått. I dag lever den i {scope}. Hvem som ser den endres med scopen.',
      error: 'Scope-flyttingen ble avvist'
    },
    start: {
      title: 'Start VM',
      submit: 'Start',
      target: 'Målnode',
      auto: 'Automatisk (anbefalt)',
      recommended: 'anbefalt',
      hint: 'Velg en målnode, eller la Proximity avgjøre blant de gyldige kandidatene. Noder som ikke kan huse den er deaktivert, med begrunnelse.',
      error: 'Kunne ikke starte VM-en'
    },
    console: {
      media: 'CD/DVD-stasjoner',
      mediaGuestToolsHint: 'Inneholder TVirt Guest Tools — herfra kan du løse dem ut eller fjerne stasjonen',
      slotOpsDeferred: 'På denne profilen tas tillegg og fjerning av stasjoner i bruk ved neste power cycle (mediebytter er umiddelbare).',
      mountGuestTools: 'Monter TVirt Guest Tools',
      ejectGuestTools: 'Løs ut TVirt Guest Tools',
      bootOrder: 'Boot-rekkefølge',
      bootOrderHint: 'Den nye rekkefølgen lagres med en gang og tas i bruk ved neste power cycle — konsollsesjonen forblir tilkoblet.'
    },
    snapshots: {
      create: 'Ta snapshot',
      createTitle: 'Ta et snapshot',
      createSubmit: 'Ta',
      name: 'Navn',
      nameHint: 'Bokstaver, sifre, punktum, bindestrek, understrek.',
      consistencyHint: 'Konsistensen er automatisk: guest-agenten fryser filsystemene når den svarer; ellers pauses VM-en et øyeblikk rundt snapshotet.',
      memory: 'Ta med minnet',
      memoryHint: 'Fanger den levende RAM-en: en tilbakestilling gjenopptar VM-en kjørende. Krever at alle diskene er qcow2.',
      currentChip: 'Du er her',
      revert: 'Tilbakestill',
      revertTitle: 'Tilbakestille til {name}?',
      revertBody: 'Diskene går tilbake til tilstanden i snapshotet; alt som skjedde etterpå går tapt. Et snapshot med bare disker krever at VM-en står.',
      delete: 'Slett',
      deleteTitle: 'Slette snapshotet {name}?',
      deleteBody: 'Gjenopprettingspunktet forsvinner; diskinnholdet forblir urørt.',
      deleteMergeHint: 'Deltaet flettes inn i {children}: hvert senere gjenopprettingspunkt forblir gyldig.',
      deleteDuplication: 'Jeg godtar dupliseringen',
      deleteDuplicationHint: 'Deltaet kopieres inn i hver av de {count} leserne (barne-snapshotene og, hvis dette er det gjeldende, det aktive hodet): den brukte plassen kan vokse i stedet for å krympe.',
      error: 'Snapshot-operasjonen ble avvist'
    },
    clone: {
      title: 'Klon VM',
      submit: 'Klon',
      name: 'Navn på kopien',
      storage: 'Mål-storage for diskene',
      sameStorage: 'Samme som kilden',
      full: 'Full kopi',
      fullHint: 'Kopierer hver byte og kutter båndet til kildediskene. Default er en linked clone: umiddelbar, men lenket til kilden (bare qcow2).',
      hint: 'Klonen beholder kildens konfigurasjon og firmware; MAC-adresser og TPM-identitet er nye.',
      markAs: 'Klonetype',
      markAsInheritVm: 'Som kilden (VM)',
      markAsInheritTemplate: 'Som kilden (template)',
      markAsVm: 'Virtuell maskin',
      markAsTemplate: 'Template',
      markAsHintVm: 'Velg Template for å forfremme kopien i ett steg.',
      markAsHintTemplate: 'Velg Virtuell maskin for å deploye fra denne templaten i ett steg.',
      error: 'Kloningen ble avvist'
    },
    bulk: {
      selected: 'valgt',
      deleteTitle: {
        one: 'Slette {count} valgt VM?',
        other: 'Slette {count} valgte VM-er?'
      },
      deleteBody: 'Hver VM passerer de samme vaktene som en enkelt sletting; avvisninger rapporteres per element.',
      done: 'akseptert',
      refused: 'avvist'
    },
    delete: {
      button: 'Slett',
      confirmTitle: 'Slette {name}?',
      confirmBody: 'Den virtuelle maskinen og diskene den eier blir slettet. Dette kan ikke angres.',
      keepDisks: 'Behold diskene',
      keepDisksHint: 'Diskene som ble opprettet med VM-en blir stående i storagen sin som frittstående disker.',
      confirm: 'Slett',
      cancel: 'Avbryt',
      error: 'Slettingen mislyktes',
      blockedPhase: 'Stopp VM-en først',
      blockedProtected: 'VM-en er beskyttet — fjern beskyttelsen først',
      blockedDeleting: 'Sletting allerede i gang'
    },
    logs: {
      title: 'Logg',
      subtitle: 'Strukturerte logg-frames fra taskene som berører denne VM-en',
      when: 'Når',
      task: 'Task',
      level: 'Nivå',
      message: 'Melding',
      empty: 'Ingen logg ennå',
      loadError: 'Kunne ikke laste loggen — er TVirt-backenden tilgjengelig?'
    },
    stop: {
      title: 'Stopp virtuell maskin',
      modeGraceful: 'Graceful nedstenging',
      modeGracefulHint: 'Guest-OS-et bes om å stenge ned pent (ACPI); ignorerer det forespørselen, følger en tvungen stopp etter timeouten.',
      modeForced: 'Tvungen stopp',
      modeForcedHint: 'Kutter strømmen umiddelbart, som å dra ut støpselet.',
      timeout: 'Fallback-timeout (sekunder)',
      timeoutHint: 'Ventetiden guesten innvilges før stoppen tvinges'
    },
    createFromScratch: 'Fra bunnen av',
    createFromTemplate: 'Fra template',
    createQuickDeploy: 'TVirt QuickDeploy',
    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Utfør deploy',
      error: 'Deploy mislyktes',
      compatNote: 'QuickDeploy krever en QuickDeploy-kompatibel mal: plattformen tilpasser gjesten (nettverk, domene, aktivering) ved første oppstart.',
      template: 'Mal',
      noTemplates: 'Ingen mal erklærer QuickDeploy-kompatibilitet ennå — erklær den fra fanen Maler (Linux med cloud-init, Windows med cloudbase-init etter sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Vertsnavn',
      hostnameHint: 'Vertsnavn eller FQDN; tomt = VM-ens navn (Windows: høyst 15 tegn)',
      ip: 'IP-adresse',
      ipHint: 'Vert og prefiks, f.eks. 192.168.122.101/24; tomt = DHCP',
      gateway: 'Gateway',
      dns: 'DNS-servere',
      dnsHint: 'Opptil tre, kommaseparert',
      count: 'Instanser',
      countHint: 'Mer enn én: navngitt <navn>-1…-N, kun DHCP',
      user: 'Bruker',
      userHint: 'Tomt = standardbrukeren i imaget (Linux) eller Administrator (Windows)',
      password: 'Passord',
      passwordHint: 'Skrives inn i den genererte user-dataen, som plattformen deretter erklærer hemmelig: ingen leser den igjen',
      sshKeys: 'Offentlige SSH-nøkler',
      sshKeysHint: 'Én per linje (ssh-ed25519 AAAA… kommentar)',
      productKey: 'Windows-produktnøkkel',
      kmsServer: 'KMS-server',
      kmsHint: 'Vert eller vert:port — krever en produktnøkkel (en KMS-klientnøkkel)',
      adDomain: 'Join Active Directory-domene',
      adDomainHint: 'Tomt = ingen domene-join',
      adUser: 'Join-konto',
      adPassword: 'Passord for join-kontoen',
      adOu: 'Mål-OU (valgfritt)',
      advanced: 'Avansert: rå dokumenter',
      userData: 'user-data (rå)',
      userDataHint: 'Overstyrer den genererte user-dataen: bruker, passord, nøkler og Windows-feltene ovenfor må forbli tomme',
      networkConfig: 'network-config (rå)',
      networkConfigHint: 'Overstyrer det genererte nettverket: IP, gateway og DNS ovenfor må forbli tomme',
      secret: 'Behandle den rå user-dataen som hemmelig',
      secretHint: 'Merket hemmelig slutter API-et å returnere den til noen, og den reiser forseglet med masterpass i Checkpointet',
      startNow: 'Start med en gang',
      startNowHint: 'Hver instans starter så snart den er definert; seedet bygges ved den oppstarten'
    },
    create: {
      nicAttachmentNetwork: 'Logisk nettverk (fabric)',
      nicNetwork: 'Logisk nettverk',
      nicNetworkHint: 'Den ANBEFALTE veien (F3): vNIC-en realiseres på den AVLEDEDE broen på den betjenende noden — broen fødes ved den eksplisitte fabric-applyen, og en start på en node som ennå ikke bærer den avslår talende. Når flåtens siste referanse forsvinner, faller broen ut ved neste apply.',
      button: 'Opprett VM',
      title: 'Opprett virtuell maskin',
      dialogTitle: 'Opprett virtuell maskin',
      stepGeneral: 'Generelt',
      stepGeneralHint: 'Navn og profil',
      stepCompute: 'CPU og RAM',
      stepComputeHint: 'Topologi og dimensjonering',
      stepDisks: 'Disker',
      stepDisksHint: 'Opprett eller koble til',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Stasjoner og medier',
      stepNetwork: 'Nettverk',
      stepNetworkHint: 'NIC-er: trunk eller bridge',
      stepSummary: 'Oppsummering',
      stepSummaryHint: 'Gjennomgå og opprett',
      name: 'Navn',
      nameHint: 'Små bokstaver, sifre og bindestreker (DNS-1123)',
      nextButton: 'Neste',
      prevButton: 'Tilbake',
      submitButton: 'Opprett',
      creating: 'Oppretter…',
      sockets: 'Sockets',
      cores: 'Kjerner per socket',
      threads: 'Tråder per kjerne',
      totalVcpus: 'vCPU totalt',
      memoryGib: 'Minne (GiB)',
      cpuModelHint: "'host' eksponerer CPU-en til hosten",
      cpuLimitHint: 'Tak i host-kjerner — tomt = ubegrenset',
      cpuNestedHint: "Eksponerer vmx/svm for gjesten slik at den kan kjøre sin egen hypervisor — krever CPU-modellen host og en node med nested aktivert",
      newDisk: 'Ny disk',
      attachDisk: 'Koble til eksisterende disk',
      diskStorage: 'Storage',
      diskSize: 'Størrelse (GiB)',
      diskSelect: 'Disk',
      addDisk: 'Legg til disk',
      addCdrom: 'Legg til CD/DVD-stasjon',
      addNic: 'Legg til nettverksgrensesnitt',
      remove: 'Fjern',
      slotLimit: 'Slot-grensen er nådd',
      cdromImage: 'Bilde (tom stasjon hvis ingen)',
      nicAttachment: 'Tilkobling',
      nicAttachmentTrunk: 'Overlay-trunk',
      nicAttachmentBridge: 'Host-bridge',
      nicUntagged: 'Utagget overlay',
      nicUntaggedNone: 'Ingen (bare tagget)',
      nicTrunkHint: 'Minst én side: et utagget overlay og/eller taggede VLAN-mappinger — VM-en kan bare kjøre på hoster som hvert refererte overlay deklarerer',
      nicTaggedVlan: 'VLAN-ID',
      nicTaggedOverlay: 'Overlay-nettverk',
      addTagged: 'Legg til tagget VLAN',
      nicBridge: 'Navn på host-bridgen',
      nicBridgeHint: 'NM-host-bridge etter navn — VM-en kan bare kjøre på servere hvis host-nettverk deklarerer denne bridgen',
      nicMac: 'MAC (auto hvis tomt)',
      noDisksHint: 'Ingen disker: VM-en får bare CD/DVD-stasjonene du legger til.',
      noCdromsHint: 'Ingen CD/DVD-stasjon: legg til en for å boote fra et ISO-bilde.',
      mountGuestTools: 'Monter TVirt Guest Tools ved første start',
      mountGuestToolsHint: 'Legger ISO-en med virtio-driverne og guest-agenten i en tom CD-stasjon (lagt til om nødvendig) — Windows-installeren trenger dem for å se diskene sine.',
      noNicsHint: 'Ingen nettverksgrensesnitt: VM-en starter uten tilkobling.',
      taggedMappings: 'Taggede VLAN-mappinger',
      summaryDevices: 'Enheter',
      bootOrderTitle: 'Boot-rekkefølge',
      bootOrderHint: 'Dra for å endre rekkefølgen — den første bootbare enheten vinner; NIC-er booter PXE',
      bootOrderUp: 'Flytt opp',
      bootOrderDown: 'Flytt ned',
      createError: 'Opprettelsen mislyktes'
    },
    edit: {
      button: 'Rediger',
      title: 'Rediger virtuell maskin',
      cancel: 'Avbryt',
      save: 'Lagre',
      error: 'Endringen mislyktes',
      modelStoppedOnly: 'Kan bare endres mens VM-en er avslått',
      firmwareStoppedOnly: 'Firmware kan bare endres mens VM-en er avslått — ved neste start starter maskinen på den nye firmwaren, og UEFI-variablene beholdes',
      hugePagesStoppedOnly: 'Kan bare endres når den virtuelle maskinen er slått av — ved neste oppstart bygges minnet på det nye underlaget',
      runningHint: 'Endringene tas i bruk ved neste power cycle',
      sectionCpu: 'CPU',
      sectionMemory: 'Minne',
      sectionPolicy: 'Policyer'
    },
    devices: {
      networkChip: 'fabric-nettverk',
      title: 'Enheter',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Legg til USB-enhet',
      addUsbTitle: 'Krev en klasse USB-enheter',
      usbClassHint:
        'VM-en ber om en KLASSE av USB-enheter (en verdi av en usb-device-tagg), aldri én bestemt enhet: ved start velges og reserveres den konkrete ledige enheten på noden. Tagg de registrerte enhetene under Kluster › USB- og PCIe-ressurser.',
      usbTag: 'Tagg (usb-device)',
      usbValue: 'Klasseverdi',
      noUsbTags: 'Ingen usb-device-tagger — opprett en og tagg de registrerte enhetene under Kluster › USB- og PCIe-ressurser.',
      noUsbValues: 'Denne taggen har ingen deklarerte verdier ennå.',
      usbEmpty: 'Ingen USB-krav — legg til en klasse for å sende en enhet gjennom ved start.',
      usbClassChip: 'klasse',
      usbPortChip: 'port',
      usbUnclaimed: 'Ingen enhet reservert — avgjøres når VM-en starter.',
      addGpu: 'Legg til GPU',
      addGpuTitle: 'Krev en GPU-klasse',
      gpuClassHint:
        'VM-en ber om en KLASSE av GPU-er (en verdi av en gpu-device-tagg), aldri ett bestemt kort: ved start velges og reserveres det konkrete ledige kortet på noden, og hele IOMMU-gruppen dets passerer gjennom SAMMEN. Tagg de registrerte GPU-ene under Kluster › USB- og PCIe-ressurser.',
      gpuTag: 'Tagg (gpu-device)',
      gpuValue: 'Klasseverdi',
      noGpuTags: 'Ingen gpu-device-tagger — opprett en og tagg de registrerte GPU-ene under Kluster › USB- og PCIe-ressurser.',
      noGpuValues: 'Denne taggen har ingen deklarerte verdier ennå.',
      gpuEmpty: 'Ingen GPU-krav — legg til en klasse for å sende et kort gjennom ved start.',
      gpuClassChip: 'klasse',
      gpuGroupChip: 'IOMMU-gruppe ×',
      gpuUnclaimed: 'Ingen kort reservert — avgjøres når VM-en starter.',
      gpuPowerCycle: 'Ingen GPU-hotplug — endringene gjelder fra neste power cycle (PendingRestart)',
      actions: 'Handlinger',
      attachDisk: 'Legg til disk',
      attachDiskTitle: 'Legg til en disk',
      attach: 'Koble til',
      noFreeDisks: 'Ingen ubrukte disker — opprett en under Virtuelle maskiner › Ubrukte disker.',
      addCdrom: 'Legg til stasjon',
      addCdromTitle: 'Legg til en CD/DVD-stasjon',
      editCdromTitle: 'Bytt CD/DVD-bilde',
      changeMedia: 'Bytt CD/DVD-bilde',
      ejectMedium: 'Løs ut',
      mountGuestTools: 'Monter TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools montert',
      guestToolsClickMount: 'Legger TVirt Guest Tools-ISO-en i den første tomme CD/DVD-stasjonen',
      guestToolsClickUnmount: 'Klikk for å løse ut — stasjonen blir stående, tom',
      guestToolsNoSlot: 'Ingen tom CD/DVD-stasjon — legg til en stasjon (eller løs ut et medium) for å montere TVirt Guest Tools',
      guestToolsSkew: 'Montert v{pinned}; node {node} leverer nå v{current}: løs ut og monter på nytt for å oppdatere',
      ejectGuestTools: 'Løs ut TVirt Guest Tools (stasjonen blir stående, tom)',
      guestToolsEjectConfirmTitle: 'Løse ut TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Mediet løses ut av den påslåtte VM-en — CD/DVD-stasjonen blir stående, tom.',
      applyLive: 'Bruk med en gang (VM-en er påslått)',
      addNic: 'Legg til grensesnitt',
      addNicTitle: 'Legg til et nettverksgrensesnitt',
      editNicTitle: 'Rediger nettverksgrensesnitt',
      bridgeChip: 'bridge',
      cable: 'Virtuell kabel',
      plug: 'Koble til den virtuelle kabelen',
      unplug: 'Koble fra den virtuelle kabelen',
      remove: 'Fjern',
      removeTitle: 'Fjerne {device}?',
      removeBody: 'På en påslått VM tas endringen i bruk ved neste power cycle. Disker og bilder blir koblet fra, aldri slettet.'
    }
  }
}
